import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { IconButton, Typography } from "@mui/material";
import { CloseIcon } from "../icons/CloseIcon";
import CheckboxGroup from "../CheckboxGroup";

export const cancelCauses = [
  { id: 1, name: "Неисправность", tooltip: "Неисправность оборудования" },
  { id: 2, name: "Хулиганство", tooltip: "Злонамеренные действия человека" },
  {
    id: 3,
    name: "Нежелательное срабатывание",
    tooltip: "Воздействие факторов, схожих с факторами пожара",
  },
  {
    id: 4,
    name: "Неизвестная причина",
    tooltip: "Причина не может быть достоверно установлена",
  },

  {
    id: 5,
    name: "Ошибочная активация",
    tooltip: "Подача сигнала о пожаре по ошибке",
  },
];
export const ModalConfirmPageWithCheckbox = ({ open, setOpen, text, call }) => {
  const [value, setValue] = useState(null);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        className="modal-title-right"
        sx={{
          justifyContent: "space-between !important",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontSize: "20px !important", fontWeight: 500 }}>
          {"Подтверждение"}
        </Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ width: "400px !important" }}>
        <DialogContentText id="alert-dialog-description" mb={"24px"}>
          {text}
        </DialogContentText>
        <CheckboxGroup
          value={value}
          onChange={setValue}
          options={cancelCauses}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            call(value);
            setValue(null);
          }}
          color="primary"
          autoFocus
          disabled={!value}
          sx={{padding: "0 24px 24px 0"}}
          className="btn btn-primary-fill"
        >
          Отправить
        </Button>
      </DialogActions>
    </Dialog>
  );
};
